export default {
    methods: {
        getRoundedPrice(price) {
            if (price === null) {
                return '';
            }
            let fgl = 1000;
            let lgl = 9999;
            const parts = price.toString().split('.');
            const wholePartAsNumber = Number(parts[0]);
            const wholePart = wholePartAsNumber >= fgl && wholePartAsNumber <= lgl
                ? parts[0] : parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1\xA0');
            return parts.length === 1 ? wholePart : wholePart + ' ' + parts[1];
        },
    },
};
